import Instance from '../../../../Axios';

// New Actions for the app

const GetEstadosEspecialidade = () => async (dispatch) => {
  await Instance()
    .get(`/construcoes/estadosEspecialidades`)
    .then(({ data }) => {
      //   console.log(data);
      dispatch({ type: 'GET_ESTADOS_ESPECIALIDADE', payload: data.yData });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetEstadosEspecialidade;
